import { useQuery } from '@apollo/client';
import { GET_CALLS_GROUPED_BY_STAGE_OUTCOME } from '../graphql/queries';

export interface CallsGroupedByStageOutcome {
  executionDate: string;
  stageOutcome: string;
  count: number;
}

interface UseCallsGroupedByStageOutcomeProps {
  startDate: Date;
  endDate: Date;
  agentId?: string;
  minDurationSecs?: number;
  maxDurationSecs?: number;
  callDirection?: 'incoming' | 'outgoing';
}

export const useCallsGroupedByStageOutcome = ({
  startDate,
  endDate,
  agentId,
  minDurationSecs,
  maxDurationSecs,
  callDirection,
}: UseCallsGroupedByStageOutcomeProps) => {
  const { loading, error, data } = useQuery(
    GET_CALLS_GROUPED_BY_STAGE_OUTCOME,
    {
      variables: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
        ...(agentId && { agentId }),
        minDurationSecs,
        maxDurationSecs,
        callDirection,
      },
    },
  );

  return {
    loading,
    error,
    data: data?.getCallsGroupedByStageOutcome as
      | CallsGroupedByStageOutcome[]
      | undefined,
  };
};
